import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { AuthService } from 'src/app/auth/services/auth.service';
import { StudentRoleSettings } from '../auth/models/UserData';
import { NavigationService } from 'src/app/shared/framework/navigation/services/navigation.service';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DefaultComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription[] = [];

  constructor(
    private _navigationService: NavigationService,
    private _authService: AuthService,
    private _router: Router
  ) { }

  ngOnInit() {
    this._subscriptions.push(
      this._authService
        .getUserRoles(true)
        .subscribe((roles: StudentRoleSettings) => {
          this._subscriptions.push(
            this._navigationService
              .fetchMenu(true)
              .pipe(take(1))
              .subscribe((menu) => {
                this._router.navigate([menu.getAngularUrl()]);
              })
          );
        })
    );
  }

  ngOnDestroy() {
    for (const subscription of this._subscriptions) {
      subscription.unsubscribe();
    }
  }
}
